module.exports = __webpack_public_path__ + "img/img-02.3302f409.png";